/**
 * StabilityMeter - Primary feedback indicator
 * 
 * Shows stability and recovery bandwidth
 * No judgment, just state
 */
export default function StabilityMeter({ stability, recoveryBandwidth }) {
  const stabilityColor = stability > 70 ? 'from-green-500 to-green-600' :
                         stability > 40 ? 'from-yellow-500 to-yellow-600' :
                         'from-red-500 to-red-600';
  
  const glowColor = stability > 70 ? 'shadow-green-500/50' :
                    stability > 40 ? 'shadow-yellow-500/50' :
                    'shadow-red-500/50';

  return (
    <div className="bg-white/5 rounded-xl p-6 border border-white/10 backdrop-blur-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-mono text-gray-300">Stability</h3>
        <div className="text-3xl font-mono font-bold">{Math.floor(stability)}%</div>
      </div>

      {/* Stability Bar */}
      <div className="relative h-6 bg-black/30 rounded-full overflow-hidden mb-4">
        <div
          className={`absolute inset-y-0 left-0 bg-gradient-to-r ${stabilityColor} ${glowColor} shadow-lg transition-all duration-500`}
          style={{ width: `${stability}%` }}
        >
          {/* Animated glow effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer" />
        </div>
      </div>

      {/* Recovery Bandwidth */}
      <div className="flex items-center justify-between text-sm">
        <span className="text-gray-500 font-mono">Recovery Bandwidth</span>
        <span className="text-blue-400 font-mono">{Math.floor(recoveryBandwidth * 100)}%</span>
      </div>
      <div className="h-2 bg-black/30 rounded-full overflow-hidden mt-2">
        <div
          className="h-full bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-500"
          style={{ width: `${recoveryBandwidth * 100}%` }}
        />
      </div>

      {/* Subtle state description */}
      <div className="mt-4 text-center text-sm text-gray-600">
        {getStateDescription(stability, recoveryBandwidth)}
      </div>
    </div>
  );
}

function getStateDescription(stability, bandwidth) {
  if (stability > 80 && bandwidth > 0.9) {
    return "System operating at full capacity";
  } else if (stability > 60) {
    return "Stable, with room to absorb shocks";
  } else if (stability > 40) {
    return "Under pressure, recovery slowing";
  } else if (stability > 20) {
    return "System strained, limited bandwidth";
  } else {
    return "Critical state, recovery severely impaired";
  }
}

